
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/mage",
      function () {
        return require("private-next-pages/extensions/mage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/mage"])
      });
    }
  